export const fadeOut = (element, duration) => {
    element.style.transition = `opacity ${duration}ms`;
    element.style.opacity = 0;
    setTimeout(() => {
        element.style.display = "none";
    }, duration);
}